import React, { useState, useEffect } from "react";
import { useContent } from "contexts/contentContext/contentContext.js";
import { Toggle } from "components/Elements/Toggle/Toggle.js";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import FormBuilderEditOptions from "./FormBuilderEditOptions.js";
import { useToasts } from "react-toast-notifications";
import { editFieldStructure } from "components/Pages/CreateJumboForm/CreateJumboFormContent/NewFormBuilder/Helper.js";
import FormBuilderTypeDropdown from "./FormBuilderTypeDropdown/FormBuilderTypeDropdown.js";
import FormBuilderRecipientElement from "./FormBuilderRecipientElement/FormBuilderRecipientElement.jsx";

const MAX_VISIBLE_FOR_INBOX = 5;

const SimpleEditField = ({
  field,
  formItems,
  setFormItems,
  formJson,
  setFormJson,
  setUpdateBeforeSave,
  includeOptions,
  formLanguage,
  setFormHeight,
  tempField,
  setTempField,
  recipientValidationErrors,
  setRecipientValidationErrors,
}) => {
  const { getTextByKey } = useContent();
  const { addToast } = useToasts();
  const [optionsList, setOptionsList] = useState([]);
  const [updateOptions, setUpdateOptions] = useState(false);
  const [fieldChanged, setfieldChanged] = useState(false);
  const [updateToggle, setUpdateToggle] = useState(false);
  const [updateJson, setUpdateJson] = useState(false);
  const [focusLabel, setFocusLabel] = useState(null);
  const [blurLabel, setBlurLabel] = useState(null);
  const [focusTooltip, setFocusTooltip] = useState(null);
  const [blurTooltip, setBlurTooltip] = useState(null);
  const [focusTextarea, setFocusTextarea] = useState(null);
  const [blurTextArea, setBlurTextArea] = useState(null);

  const [specialFields, setSpecialFields] = useState(false);
  const [isSperatorField, setIsSperatorField] = useState(false);
  useEffect(() => {
    if (field && field.fields) {
      setTempField(field);
    }
  }, [field]);

  useEffect(() => {
    //if tempField.tempate === "speratorstatic" || "titlestatic" || "textstatic" then setSpecialFields(true)
    if (
      tempField.template === "speratorstatic" ||
      tempField.template === "titlestatic" ||
      tempField.template === "textstatic"
    ) {
      setSpecialFields(true);
    } else {
      setSpecialFields(false);
    }
    if (tempField.template === "speratorstatic") {
      setIsSperatorField(true);
    } else {
      setIsSperatorField(false);
    }
  }, [tempField]);

  const handleEmailRequiredLogic = (callback) => {
    if (field.template === "emailinput") {
      const existAnotherEmailInputRequired = formItems.some(
        (item) =>
          item.template === "emailinput" &&
          item.fields.required &&
          item.id !== field.id
      );
      return existAnotherEmailInputRequired;
    } else {
      return true;
    }
  };

  const handleChangeRequired = () => {
    const existAnotherEmailInputRequired = handleEmailRequiredLogic();
    if (!existAnotherEmailInputRequired && tempField.fields.required) {
      addToast(getTextByKey("at-least-one-email-required"), {
        appearance: "error",
      });
      return;
    }
    let tempRequired = tempField.fields.required;
    setTempField({
      ...tempField,
      fields: { ...tempField.fields, required: !tempRequired },
    });
    setUpdateToggle(true);
    setfieldChanged(true);
  };

  const handleChangeReadonly = () => {
    let tempReadonly = tempField.fields.readonly;
    setTempField({
      ...tempField,
      fields: { ...tempField.fields, readonly: !tempReadonly },
    });
    setUpdateToggle(true);
    setfieldChanged(true);
  };

  const handleChangeAutoSave = () => {
    let tempAutoSave = tempField.fields.tempsave;
    setTempField({
      ...tempField,
      fields: { ...tempField.fields, tempsave: !tempAutoSave },
    });
    setUpdateToggle(true);
    setfieldChanged(true);
  };

  const handleChangeDownloadName = () => {
    let tempDownloadName = tempField.fields.downloadname;
    let countDownload = countDownloadName();
    let enableToggle = false;
    if (!tempDownloadName) {
      if (countDownload < 3) {
        enableToggle = true;
      }
    } else {
      enableToggle = true;
    }

    if (enableToggle) {
      setTempField({
        ...tempField,
        fields: { ...tempField.fields, downloadname: !tempDownloadName },
      });
      setUpdateToggle(true);
      setfieldChanged(true);
    } else {
      addToast(getTextByKey("max-limit-zip"), {
        appearance: "error",
      });
    }
  };

  //count how many fields include prop downloadname
  const countDownloadName = () => {
    let count = 0;
    formItems.forEach((item) => {
      if (item.fields.downloadname) {
        count++;
      }
    });
    return count;
  };

  const handleChangeIncludeInSubject = () => {
    let countIncludeInSubject = countInlcudeInSubjectFields();
    let tempIncludeInSubject = tempField.fields.includeinemailsubject;
    let enableToggle = false;
    if (!tempIncludeInSubject) {
      if (countIncludeInSubject < 5) {
        enableToggle = true;
      }
    } else {
      enableToggle = true;
    }

    if (enableToggle) {
      setTempField({
        ...tempField,
        fields: {
          ...tempField.fields,
          includeinemailsubject: !tempIncludeInSubject,
        },
      });
      setUpdateToggle(true);
      setfieldChanged(true);
    } else {
      addToast(getTextByKey("max-limit-subject"), {
        appearance: "error",
      });
    }
  };

  //count how many fields include prop includeinemailsubject
  const countInlcudeInSubjectFields = () => {
    let count = 0;
    formItems.forEach((item) => {
      if (item.fields.includeinemailsubject) {
        count++;
      }
    });
    return count;
  };

  const handleChangeLabel = (e) => {
    //if tempField.field is titlestatic - max length 50. if tempField.field is textstatic - max length 500
    if (tempField.template === "titlestatic") {
      if (e.length > 50) {
        //save the first 50 characters
        e = e.substring(0, 50);
      }
    }
    if (tempField.template === "textstatic") {
      if (e.length > 500) {
        //save the first 500 characters
        e = e.substring(0, 500);
      }
    }
    setTempField({ ...tempField, fields: { ...tempField.fields, label: e } });
    setfieldChanged(true);
  };

  const handleChangeTooltip = (e) => {
    setTempField({
      ...tempField,
      fields: { ...tempField.fields, helptext: e },
    });
    setfieldChanged(true);
  };

  const handleChangeTextarea = (e) => {
    setTempField({
      ...tempField,
      fields: { ...tempField.fields, textarea: e },
    });
    setfieldChanged(true);
  };

  const makeAsSubject = () => {
    // No more than 3 subject fields can be selected
    // https://youtrack.jumbomail.me/issue/JW-2605/Allow-the-user-to-select-3-fields-in-the-form-for-the-subject-in-the-inbox
    const isThreeSubjectFieldsSelected =
      formItems.filter(({ fields }) => fields.isSubject).length === 3;
    const isCurrentFieldSubject = tempField.fields.isSubject;
    // If user trying to turn option on and there is already 3 subject fields selected
    if (isThreeSubjectFieldsSelected && !isCurrentFieldSubject) {
      addToast(getTextByKey("subject-fields-already-selected"), {
        appearance: "error",
      });
      return;
    } else {
      setTempField({
        ...tempField,
        fields: { ...tempField.fields, isSubject: !tempField.fields.isSubject },
      });
      setfieldChanged(true);
      setUpdateToggle(true);
    }
  };

  const setVisibleForInbox = () => {
    // Don't allow to set more than 5 fields visible for inbox
    const visibleForInboxFields = formItems.filter(
      ({ fields }) => fields.isVisibleForInbox
    );

    if (
      visibleForInboxFields.length >= MAX_VISIBLE_FOR_INBOX &&
      !tempField.fields.isVisibleForInbox
    ) {
      addToast(getTextByKey("max-limit-visible-for-inbox"), {
        appearance: "error",
      });

      return;
    } else {
      setTempField({
        ...tempField,
        fields: {
          ...tempField.fields,
          isVisibleForInbox: !tempField.fields.isVisibleForInbox,
        },
      });
      setfieldChanged(true);
      setUpdateToggle(true);
    }
  };

  const setShowMailInInbox = () => {
    setTempField({
      ...tempField,
      fields: {
        ...tempField.fields,
        showMailInInbox: !tempField.fields.showMailInInbox,
      },
    });
    setfieldChanged(true);
    setUpdateToggle(true);
  };

  useEffect(() => {
    if (tempField && fieldChanged) {
      let tempFormItems = formItems.map((item) => {
        if (item.id === tempField.id) {
          return tempField;
        } else {
          return item;
        }
      });
      setFormItems(tempFormItems);
      setfieldChanged(false);
      if (updateToggle) {
        let tempFormJson = { ...formJson };
        tempFormJson.items = tempFormItems;
        setFormJson(tempFormJson);
        setUpdateJson(true);
        setUpdateToggle(false);
      }
    }
  }, [tempField, fieldChanged, updateToggle]);

  useEffect(() => {
    if (blurLabel !== focusLabel) {
      let tempFormJson = { ...formJson };
      tempFormJson.items = formItems;
      setFormJson(tempFormJson);
      setUpdateJson(true);
    }
  }, [blurLabel]);

  useEffect(() => {
    if (blurTooltip !== focusTooltip) {
      let tempFormJson = { ...formJson };
      tempFormJson.items = formItems;
      setFormJson(tempFormJson);
      setUpdateJson(true);
    }
  }, [blurTooltip]);

  useEffect(() => {
    if (blurTextArea !== focusTextarea) {
      let tempFormJson = { ...formJson };
      tempFormJson.items = formItems;
      setFormJson(tempFormJson);
      setUpdateJson(true);
    }
  }, [blurTextArea]);

  useEffect(() => {
    if (formJson && updateJson) {
      setUpdateBeforeSave({
        mode: true,
        action: "updateJson",
        heightChanged: true,
      });
      setUpdateJson(false);
    }
  }, [formJson, updateJson]);

  useEffect(() => {
    if (tempField && updateOptions) {
      let tempFormItems = formItems.map((item) => {
        if (item.id === tempField.id) {
          return tempField;
        } else {
          return item;
        }
      });
      setFormItems(tempFormItems);
      let tempFormJson = { ...formJson };
      tempFormJson.items = tempFormItems;
      setFormJson(tempFormJson);
      setUpdateOptions(false);
      setUpdateJson(true);
    }
  }, [updateOptions, tempField]);

  const listToggles = [
    {
      Name: "required",
      Label: getTextByKey("attr-required"),
      Tooltip: getTextByKey("required-tooltip"),
      state: tempField.fields.required,
      setState: handleChangeRequired,
    },
    {
      Name: "readonly",
      Label: getTextByKey("attr-readonly"),
      Tooltip: getTextByKey("readonly-tooltip"),
      state: tempField.fields.readonly,
      setState: handleChangeReadonly,
    },
    {
      Name: "tempsave",
      Label: getTextByKey("attr-tempsave"),
      Tooltip: getTextByKey("tempsave-tooltip"),
      state: tempField.fields.tempsave,
      setState: handleChangeAutoSave,
    },
    {
      Name: "downloadname",
      Label: getTextByKey("attr-download-name"),
      Tooltip: getTextByKey("downloadname-tooltip"),
      state: tempField.fields.downloadname,
      setState: handleChangeDownloadName,
    },
    {
      Name: "includeinemailsubject",
      Label: getTextByKey("attr-include-in-email-subject"),
      Tooltip: getTextByKey("includesubject-tooltip"),
      state: tempField.fields.includeinemailsubject,
      setState: handleChangeIncludeInSubject,
    },
    // Make this field the subject of the mail in the inbox
    {
      Name: "isSubject",
      Label: getTextByKey("make-subject"),
      Tooltip: getTextByKey("make-subject-tooltip"),
      state: tempField.fields.isSubject,
      setState: makeAsSubject,
    },
    {
      Name: "isVisibleForInbox",
      Label: getTextByKey("make-visible-for-inbox"),
      Tooltip: getTextByKey("make-visible-for-inbox-tooltip"),
      state: tempField.fields.isVisibleForInbox,
      setState: setVisibleForInbox,
    },
    {
      Name: "showMailInInbox",
      Label: getTextByKey("attr-show-in-inbox"),
      Tooltip: getTextByKey("attr-show-in-inbox-tooltip"),
      state: tempField.fields.showMailInInbox,
      setState: setShowMailInInbox,
    },
  ];

  const updateOptionsFunction = () => {
    if (tempField) {
      switch (tempField.template) {
        case "selectbasic":
          setTempField({
            ...tempField,
            fields: { ...tempField.fields, options: optionsList },
          });
          break;
        case "multipleradios":
          setTempField({
            ...tempField,
            fields: { ...tempField.fields, radios: optionsList },
          });
          break;
        case "multiplecheckboxes":
          setTempField({
            ...tempField,
            fields: {
              ...tempField.fields,
              checkboxes: optionsList,
            },
          });
          break;
        case "recipientDropdown":
          setTempField({
            ...tempField,
            fields: { ...tempField.fields, options: optionsList },
          });
          break;
        default:
          break;
      }
      setUpdateOptions(true);
    }
  };

  const checkIsVisibleForInboxSupported = (tempField) => {
    const fieldType = tempField.template;
    const supportedFieldTypes = [
      "textinput",
      "numberinput",
      "urlinput",
      "dateinput",
      "textarea",
      "multipleradios",
      "recipientDropdown",
    ];

    return supportedFieldTypes.includes(fieldType);
  };

  const checkIsSubjectSupported = (tempField) => {
    const fieldType = tempField.template;
    const supportedFieldTypes = ["textinput", "urlinput", "dateinput"];

    return supportedFieldTypes.includes(fieldType);
  };

  const checkIsOptionsSupported = (tempField, toggleName) => {
    if (toggleName === "isVisibleForInbox") {
      return checkIsVisibleForInboxSupported(tempField);
    } else if (toggleName === "isSubject") {
      return checkIsSubjectSupported(tempField);
    } else {
      return tempField.fields[toggleName] !== undefined;
    }
  };

  return (
    <div className="edit-field-content simple">
      {tempField.template === "recipientDropdown" && (
        <>
          <FormBuilderTypeDropdown
            tempField={tempField}
            setTempField={setTempField}
            setfieldChanged={setfieldChanged}
            setUpdateToggle={setUpdateToggle}
          />
          <FormBuilderRecipientElement
            tempField={tempField}
            setTempField={setTempField}
            setfieldChanged={setfieldChanged}
            setUpdateToggle={setUpdateToggle}
            recipientValidationErrors={recipientValidationErrors}
            setRecipientValidationErrors={setRecipientValidationErrors}
          />
        </>
      )}
      {!isSperatorField && tempField.template !== "recipientDropdown" && (
        <div className="label input-part">
          <p>{getTextByKey("attr-label")}</p>
          {tempField.template === "textstatic" ? (
            <textarea
              className="textstatic-input"
              value={tempField.fields.label}
              onChange={(e) => handleChangeLabel(e.target.value)}
              onFocus={(e) => setFocusLabel(e.target.value)}
              onBlur={(e) => setBlurLabel(e.target.value)}
            />
          ) : (
            <input
              type="text"
              value={tempField.fields.label}
              onChange={(e) => handleChangeLabel(e.target.value)}
              onFocus={(e) => setFocusLabel(e.target.value)}
              onBlur={(e) => setBlurLabel(e.target.value)}
            />
          )}
          {tempField.template === "textstatic" ||
          tempField.template === "titlestatic" ? (
            <div className="max-chars">
              <span className="show-chars" style={{ direction: "ltr" }}>
                {tempField.fields.label.length} /{" "}
                {tempField.template === "textstatic" ? 500 : 50}
              </span>
            </div>
          ) : null}
        </div>
      )}
      {includeOptions && (
        <FormBuilderEditOptions
          setUpdateOptions={setUpdateOptions}
          field={tempField}
          optionsList={optionsList}
          setOptionsList={setOptionsList}
          updateOptionsFunction={updateOptionsFunction}
        />
      )}
      {!isSperatorField && (
        <div className="tooltip-field input-part">
          <p>{getTextByKey("attr-helptext")}</p>
          <input
            value={tempField.fields.helptext}
            onChange={(e) => handleChangeTooltip(e.target.value)}
            onFocus={(e) => setFocusTooltip(e.target.value)}
            onBlur={(e) => setBlurTooltip(e.target.value)}
            type="text"
          />
        </div>
      )}
      {tempField.fields.textarea && (
        <div className="textarea-field input-part">
          <p>{getTextByKey("attr-textarea")}</p>
          <input
            value={tempField.fields.textarea}
            onChange={(e) => handleChangeTextarea(e.target.value)}
            onFocus={(e) => setFocusTextarea(e.target.value)}
            onBlur={(e) => setBlurTextArea(e.target.value)}
            type="text"
          />
        </div>
      )}
      <div className="field-toggles-container">
        {!specialFields &&
          listToggles.map(
            (toggle, i) =>
              checkIsOptionsSupported(tempField, toggle.Name) && (
                <div key={i} className="field-toggle">
                  <Toggle status={toggle.state} setStatus={toggle.setState} />

                  <div className="toggle-textAndTooltip">
                    <span className="toggle-text">
                      {getTextByKey(toggle.Label)}
                    </span>
                    <Tooltip
                      id={toggle.Label}
                      tooltipTextKey={toggle.Tooltip}
                      top
                    >
                      <div className={`tootltip-icon-container`}>
                        <Icon
                          name="question-circle"
                          iconClass="tooltip-question"
                        />
                      </div>
                    </Tooltip>
                  </div>
                </div>
              )
          )}
      </div>
    </div>
  );
};

export default SimpleEditField;
